<template>
  <div class="mx-auto">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: "TheAboutCover",
}
</script>

<style scoped>
  div {
    max-height: 488px;
    max-width: 370px;
    text-align: center;
    overflow: hidden;
  }
</style>